<template>
  <div v-if="this.currentArticle !== null" id="article">
    <div id="header">
      <HamburgerWhite/>
      <img id="header-picture" :src="headerImg">
      <div class="header-text">
        <p class="">{{stringOfTags}}</p>
        <h2>{{currentArticle.title.rendered}}</h2>
      </div>
    </div>
    <div id="article-wrapper">
    <div class="container">
      <div class="main-content">
        <div id="header-one" class="part">
          <p class="playfair-normal">{{currentArticle.acf.rubrik_1}}</p>
          <div v-html="currentArticle.acf.text_1" class="bread">
          </div>
        </div>
        <div id="header-two" class="part">
          <p class="playfair-normal">{{currentArticle.acf.rubrik_2}}</p>
          <div v-html="currentArticle.acf.text_2" class="bread">
          </div>
        </div>
        <div id="header-three" class="part">
          <p class="playfair-normal">{{currentArticle.acf.rubrik_3}}</p>
          <div v-html="currentArticle.acf.text_3" class="bread">
          </div>
        </div>
        <div id="header-four" class="part">
          <p class="playfair-normal">{{currentArticle.acf.rubrik_4}}</p>
          <div v-html="currentArticle.acf.text_4" class="bread">
          </div>
        </div>
        <div class="part">
          <p class="playfair-normal">Vill du veta mer?</p>
          <p v-if="currentArticle.acf.las_mer_lank" class="bread read-more">Läs mer <a :href="currentArticle.acf.las_mer_lank">här</a></p>
          <p class="bread read-more">Kontakta <a href="mailto:stefan.folster@reforminstitutet.se">Stefan Fölster</a></p>
        </div>
        <div class="tags">
          <button class="tag" v-for="tag in articleTags" :key="tag.id">{{ tag.name }}</button>
        </div>
        <div id="line"></div>
        <p id="more" class="playfair-italic">Mer under {{this.stringOfTags}}</p>
        <ArticleGrid/>
      </div>
      <div class="side-nav">
        <div class="side-nav-container">
          <div class="disposition">
          <h6>Disposition</h6>
          <ol>
            <li :id="linkId[0].id" v-scroll-to="{ el: '#header-one', offset: -65 }"><p class="arial-small">{{this.currentArticle.acf.rubrik_1}}</p></li>
            <li :id="linkId[1].id" v-scroll-to="{ el: '#header-two', offset: -65 }"><p class="arial-small">{{this.currentArticle.acf.rubrik_2}}</p></li>
            <li :id="linkId[2].id" v-scroll-to="{ el: '#header-three', offset: -65 }"><p class="arial-small">{{this.currentArticle.acf.rubrik_3}}</p></li>
            <li :id="linkId[3].id" v-scroll-to="{ el: '#header-four', offset: -65 }"><p class="arial-small">{{this.currentArticle.acf.rubrik_4}}</p></li>
          </ol>
        </div>
        <div class="disposition social">
          <h6>Dela & kommentera reformen</h6>
          <div class="soc-med">
            <div class="linkedin" @click="shareLinkedIn()"></div>
            <div class="facebook" @click="shareFB()"></div>
            <!--<div class="google"></div>-->
            <div class="twitter" @click="shareTwitter()"></div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import ArticleGrid from './ArticleGrid'
import HamburgerWhite from './HamburgerWhite'
export default {
  name: 'Article',
  data () {
    return {
      clickedArticle: null,
      articleTags: [],
      linkId: [{id: 'bold'}, {id: ''}, {id: ''}, {id: ''}],
      stringOfTags: ''
    }
  },
  props: ['slug'],
  computed: {
    posts () {
      return this.$store.state.posts
    },
    theTags () {
      return this.$store.state.tags
    },
    currentArticle () {
      const self = this
      let post = this.posts.filter(a => {
        return a.slug === self.slug
      })
      if (post.length < 1) {
        return {
          id: 0,
          title: '...',
          acf: {
            rubrik1: '...',
            image: false
          },
          tags: []
        }
      } else {
        //  this.$store.dispatch('getArticle', post[0])
        return post[0]
      }
    },
    headerImg () {
      if (this.currentArticle && this.currentArticle.acf.image) {
        return this.currentArticle.acf.image.sizes.high_res
      } else {
        return '/static/FFFFFF-0.8.png'
      }
    }
  },
  methods: {
    shareFB () {
      if (window.FB) {
        window.FB.ui({
          method: 'share',
          href: window.location.href
        }, (response) => { })
      }
    },
    shareLinkedIn (ev) {
      window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=420,width=650')
    },
    shareTwitter (ev) {
      window.open('https://twitter.com/intent/tweet?url=' + window.location.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600')
      return false
    },
    handleScroll () {
      var divs = document.querySelectorAll('.part')
      var partFour = divs[4].getBoundingClientRect().bottom
      var partLineOffset = document.getElementById('line').offsetTop
      var menu = document.querySelector('.side-nav-container')
      if (partFour < 337) {
        menu.style.position = 'absolute'
        menu.style.top = partLineOffset - 950 + 'px'
      } else if (window.pageYOffset >= 480) {
        menu.style.position = 'fixed'
        menu.style.top = '0px'
      } else {
        menu.style.position = 'static'
        menu.style.top = ''
      }

      for (let index = 0; index < divs.length; index++) {
        var divBottom = divs[index].getBoundingClientRect().bottom
        var divTop = divs[index].getBoundingClientRect().top
        if (divTop < 100 && divBottom > 0) {
          this.linkId.map(function (item, i) {
            if (index === i) {
              item.id = 'bold'
            } else {
              item.id = ''
            }
          })
        }
      }
    },
    refresh () {
      this.clickedArticle = this.$store.state.currentArticle
      var theArticle = this.currentArticle
      var artTags = []
      var tagString = ''
      var comma = ''
      if (theArticle.tags.length < 1) {
        comma = ''
      } else {
        comma = ', '
      }
      this.$store.state.tags.map(function (item) {
        theArticle.tags.map(function (tag) {
          if (item.id === tag) {
            artTags.push(item)
            tagString += item.name + comma
          }
        })
      })
      var cropIndex = tagString.length - 2
      var croppedString = tagString.slice(0, cropIndex)
      this.articleTags = artTags
      this.stringOfTags = croppedString
      window.scroll({
        top: 0
      })
      this.linkId.map(function (item, i) {
        if (i === 0) {
          item.id = 'bold'
        } else {
          item.id = ''
        }
      })
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    currentArticle () {
      this.refresh()
      this.$store.dispatch('getArticle', this.currentArticle)
      window.scroll({
        top: 0
      })
    }
  },
  beforeMount () {
    if (this.slug) {
      this.$store.dispatch('getArticle', this.currentArticle)
    }
    //  console.log('watch posts', this.posts)
    //  console.log('article beforemount')
    /* this.clickedArticle = this.$store.state.currentArticle
    var theArticle = this.currentArticle
    var artTags = []
    var tagString = ''
    var comma = ''
    if (theArticle.tags.length < 1) {
      comma = ''
    } else {
      comma = ', '
    }
    this.$store.state.tags.map(function (item) {
      theArticle.tags.map(function (tag) {
        if (item.id === tag) {
          artTags.push(item)
          tagString += item.name + comma
        }
      })
    })
    var cropIndex = tagString.length - 2
    var croppedString = tagString.slice(0, cropIndex)
    this.articleTags = artTags
    this.stringOfTags = croppedString */
  },
  mounted () {
    window.scroll({
      top: 0
    })
  },
  components: { ArticleGrid, HamburgerWhite }
}
</script>

<style lang="scss" scoped>
#article-wrapper {
  display: flex;
  justify-content: center;
}
#article {
  margin-bottom: 100px;
}
#header {
  height: 480px;
  background-color: $mediumGrey;
  position: relative;
  width: 100%;
  #logo-wrapper {
    position: absolute;
  }
  #logo {
    width: 218px;
    height: 25px;
    margin: 15px 0px 0px 20px;
    position: absolute;
  }
  #header-picture {
    width: 100%;
    height: 480px;
    object-fit: cover;
    object-position: center;
  }
  .header-text {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: "Playfair Display";
    font-weight: 900;
    font-style: normal;
    p {
      color: white;
      display: inline-flex;
      font-size: 16px;
      line-height: 19px;
      margin: 0px 10px;
    }
    h2 {
      font-size: 50px;
      line-height: 67px;
      padding: 15px;
      color: white;
      max-width: 1100px;
      text-shadow: 0 0 5px rgba(0,0,0,0.5);
    }
  }
}
.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .main-content {
    max-width: 620px;
    text-align: left;
  }
}
.main-content {
  display: block;
  /*
  display: flex;
  flex-direction: column;
  align-items: flex-end; */
  .part {
    text-align: left;
    margin-top: 65px;
    background: white;
    max-width: 620px;
    width: 90vw;
  }
  .bread {
    margin-top: 18px;
  }
  .read-more a {
    color: $black;
    text-decoration: underline;
    &:hover {
      color: $purple;
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    width: 50%;
    margin: 40px 0px;
    width: 100%;

    button {
      background: $purple;
      color: white;
      border: none;
      cursor: default;
      font-size: 19px;
      min-width: 150px;
      height: 40px;
      box-sizing: border-box;
      margin: 20px 2% 0px 0px;
    }
  }
  #line {
    width: 100%;
    height: 2px;
    margin-top: 20px;
    margin-bottom: 10px;
    background: $lightGrey;
  }
  #more {
    text-align: left;
    width: 100%;
    margin-top: 40px;
    margin-bottom: 10px;
  }
}
.side-nav {
  width: 228px;
  margin-left: 40px;
  position: relative;
  .disposition {
    margin-top: 65px;
    text-align: left;
    border-left: 5px solid #800756;
    &.social {
      margin-top: 40px;
      width: 230px;
    }
    #bold {
      font-weight: bold;
    }
    li {
      list-style: decimal;
      list-style-position: inside;
      margin: 14px 0px 14px 15px;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      cursor: pointer;
      width: 100%;
    }
    p {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      display: inline;
    }
    .soc-med {
      margin-left: 15px;
      margin-top: 12px;
      width: 167px;
      display: flex;
      justify-content: flex-start;
      div {
        transition: all 0.2s ease;
        margin-right: 10px;
        &:hover {
          transform: scale(0.92);
        }
      }
    }
    .linkedin {
      background: url('../assets/img/rb_linkedin.svg');
      background-size: cover;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
    .facebook {
      background: url('../assets/img/rb_facebook.svg');
      background-size: cover;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
    .google {
      background: url('../assets/img/rb_google.svg');
      background-size: cover;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
    .twitter {
      background: url('../assets/img/rb_twitter.svg');
      background-size: cover;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
  }
}
.tag-wrapper {
  margin: 20px 0px 20px 0px;
  width: 620px;
  display: flex;
  .tag-btn {
    width: 147px;
    height: 40px;
    background: #800756;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media only screen and (max-width: 1024px) {
  .main-content {
    width: 90vw;
   .tags {
      justify-content: center;
    }
  }
  .side-nav {
    display: none;
  }
  #header > #logo-wrapper {
    position: absolute;
    width: 100%;
  }
  #header > #logo-wrapper > #logo {
    transform: scale(0.7);
    margin: 20px 0px 0px 0px;
    position: static;
    float: left;
  }
}

@media only screen and (max-width: 780px) {
  #header {
    height: 300px;
    #header-picture {
      height: 300px;
    }
    .header-text > h2 {
      font-size: 40px;
      line-height: 1.1em;
    }
  }
}
@media only screen and (max-width: 440px) {
  #header {
    height: 265px;
    #header-picture {
      height: 265px;
    }
    #logo-wrapper > #logo {
      float: none;
    }
  }
  .header-text p {
    font-size: 20px;
  }
  #header .header-text > h2 {
    font-size: 9vw;
    line-height: 11vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue